import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<UserStream @stream={{this.model}} />",{ moduleName: "discourse/templates/user/posts.hbs" })